export const CULTIVOS = [{
  'nombre': 'Vid',
  'visible': 1
},
{
  'nombre': 'Olivo',
  'visible': 1
},
{
  'nombre': 'Albaricoquero',
  'visible': 1
},
{
  'nombre': 'Caqui',
  'visible': 1
},
{
  'nombre': 'Platano',
  'visible': 1
},
{
  'nombre': 'Ciruelo',
  'visible': 1
},
{
  'nombre': 'Clementino',
  'visible': 1
},
{
  'nombre': 'Frambueso',
  'visible': 1
},
{
  'nombre': 'Fresales',
  'visible': 1
},
{
  'nombre': 'Aguacate',
  'visible': 1
},
{
  'nombre': 'Cebada',
  'visible': 1
},
{
  'nombre': 'Avena',
  'visible': 1
},
{
  'nombre': 'Centeno',
  'visible': 1
},
{
  'nombre': 'Maiz',
  'visible': 1
},
{
  'nombre': 'Cerezo',
  'visible': 1
},
{
  'nombre': 'Girasol',
  'visible': 1
},
{
  'nombre': 'Granado',
  'visible': 1
},
{
  'nombre': 'Kiwi',
  'visible': 1
},
{
  'nombre': 'Limonero',
  'visible': 1
},
{
  'nombre': 'Mandarino',
  'visible': 1
},
{
  'nombre': 'Mango',
  'visible': 1
},
{
  'nombre': 'Manzano',
  'visible': 1
},
{
  'nombre': 'Melocotonero',
  'visible': 1
},
{
  'nombre': 'Melon',
  'visible': 1
},
{
  'nombre': 'Membrillero',
  'visible': 1
},
{
  'nombre': 'Naranjo',
  'visible': 1
},
{
  'nombre': 'Nectarino',
  'visible': 1
},
{
  'nombre': 'Nispero',
  'visible': 1
},
{
  'nombre': 'Peral',
  'visible': 1
},
{
  'nombre': 'Piña',
  'visible': 1
},
{
  'nombre': 'Pomelo',
  'visible': 1
},
{
  'nombre': 'Remolacha',
  'visible': 1
},
{
  'nombre': 'Sandia',
  'visible': 1
},
{
  'nombre': 'Otros',
  'visible': 1
},
{
  'nombre': 'Semillas',
  'visible': 0
},
{
  'nombre': 'Trigo',
  'visible': 1
},
{
  'nombre': 'Uva de mesa',
  'visible': 1
},
{
  'nombre': 'Ajos',
  'visible': 1
},
{
  'nombre': 'Alcachofa',
  'visible': 1
},
{
  'nombre': 'Berenjena',
  'visible': 1
},
{
  'nombre': 'Brócoli',
  'visible': 1
},
{
  'nombre': 'Calabacín',
  'visible': 1
},
{
  'nombre': 'Col',
  'visible': 1
},
{
  'nombre': 'Col china',
  'visible': 1
},
{
  'nombre': 'Col de bruselas',
  'visible': 1
},
{
  'nombre': 'Coliflor',
  'visible': 1
},
{
  'nombre': 'Escarola',
  'visible': 1
},
{
  'nombre': 'Espinaca',
  'visible': 1
},
{
  'nombre': 'Lechuga',
  'visible': 1
},
{
  'nombre': 'Pepino',
  'visible': 1
},
{
  'nombre': 'Pimiento',
  'visible': 1
},
{
  'nombre': 'Tomate',
  'visible': 1
},
{
  'nombre': 'Acelga',
  'visible': 1
},
{
  'nombre': 'Calabaza',
  'visible': 1
},
{
  'nombre': 'Cebolla',
  'visible': 1
},
{
  'nombre': 'Endibia',
  'visible': 1
},
{
  'nombre': 'Chalote',
  'visible': 1
},
{
  'nombre': 'Patata',
  'visible': 1
},
{
  'nombre': 'Alubia verde',
  'visible': 1
},
{
  'nombre': 'Judia Verde',
  'visible': 1
},
{
  'nombre': 'Alubia grano',
  'visible': 1
},
{
  'nombre': 'Judia grano',
  'visible': 1
},
{
  'nombre': 'Berro',
  'visible': 1
},
{
  'nombre': 'Cebollino',
  'visible': 1
},
{
  'nombre': 'Triticale',
  'visible': 1
},
{
  'nombre': 'Pepinillo',
  'visible': 1
},
{
  'nombre': 'Guisante',
  'visible': 1
},
{
  'nombre': 'Haba',
  'visible': 1
},
{
  'nombre': 'Zanahoria',
  'visible': 1
},
{
  'nombre': 'Almendro',
  'visible': 1
},
{
  'nombre': 'Arándano',
  'visible': 1
},
{
  'nombre': 'Arroz',
  'visible': 1
},
{
  'nombre': 'Banana',
  'visible': 1
},
{
  'nombre': 'Borraja',
  'visible': 1
},
{
  'nombre': 'Cardo',
  'visible': 1
},
{
  'nombre': 'Colza',
  'visible': 1
},
{
  'nombre': 'Espárrago',
  'visible': 1
},
{
  'nombre': 'Puerro',
  'visible': 1
},
{
  'nombre': 'Naranja',
  'visible': 1
},
{
  'nombre': 'Brécol',
  'visible': 1
},
{
  'nombre': 'Lima',
  'visible': 1
},
{
  'nombre': 'Leguminosas de grano',
  'visible': 1
},
{
  'nombre': 'Barbecho',
  'visible': 1
},
];
